import React, { Fragment } from 'react'
import "./searchforpage.css";
import PageSearchItemModified from './PageSearchItemModified';
import { STATUS } from '../../Constants';
import { Skeleton } from '@mui/material';
import { TailSpin } from 'react-loader-spinner';

function PageSearchListModified({data , status}) {

    return (
        <Fragment>
            {
                status === STATUS.LOADDING ? 
                (
                        <div style={{display :"flex" , marginTop : "200px" , justifyContent :"center" , alignItems :"center"}}>
                        <TailSpin
                        visible={true}
                        height="120"
                        width="120"
                        color="#0075FF"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass=""
                        />
                        </div>
                ) :""
            }
            {status === STATUS.SUCCESS ? (
                <div className='table-search'>
                <div className='table-header'>
                    <p className='table-cell'>Name</p>
                    <p className='table-cell'>Category</p>
                    <p className='table-cell'>Likes </p>
                    <p className='table-cell'>Website </p>
                    <p className='table-cell cell-address'>Location </p>
                    <p className='table-cell'>Verified </p>
                    <p className='table-cell'>Posts </p>
                </div>
                <div className='table-body'>

                    {
                    status === STATUS.SUCCESS ? 
                    data.length > 0 ? 
                    data.map((item)=>{
                        return(<PageSearchItemModified cat={item.profile?.category} fanCount={item?.profile?.fan_count} website={item?.profile?.website} verified={item.verification_status ==="blue_verified"} key={item.id} name={item?.name} id={item?.id} location={item?.location}  />)
                    })
                    :"":""
                    }
                </div>
            </div>
            ) :""}
        </Fragment>
    )
}

export default PageSearchListModified
